import { Constants } from "./../constants";
import { GenericScreenController } from "./generic-screen-controller";
import { IScreenStatusCommand } from "./../screen-status-command";
import { NavigationBarManager } from "../navigation-bar-manager";

/**
 * Workflow Controller for screen 9 with custom logic
 */
export class Screen9Controller extends GenericScreenController {

    LOW = 0;
    MODERATE = 2.5;
    SEVERE = 4;

    TOTAL_ASSESMENT_QUESTIONS = 4;

    selfSelectCheckbox = this.screenDomElement.find(".FormChoice input[type='checkbox']");
    selfSelectStatus: boolean = false;

    questionsSelects = this.screenDomElement.find(".Form__Element.FormSelection select");

    constructor(index: number, navigationBarManager: NavigationBarManager) {
        super(index, navigationBarManager);
        this.navigationStatus.progressBarGroupIndex = Constants.GROUP_INDEX_3;
    }

    public initEvents() {
        let self = this;

        // Event when the user check the option "Self-Select Dependency Option"
        $(this.selfSelectCheckbox).change(function (e) {
            self.selfSelectStatus = $(e.target).is(':checked');
            self.clearDropdowns();
            self.updateNextButtonStatus();
        });

        // Each time the user selects an option, proceed to show the message that
        // corresponds to the average
        $(this.screenDomElement.find(".FormSelection select")).change(function () {
            self.updateDependencyLevelMessage();
        });
    }

    public calculateNextScreensInFlow(): Array<IScreenStatusCommand> {
        let visibilityChangeRequest: Array<IScreenStatusCommand> = new Array<IScreenStatusCommand>();

        let average: number = this.calculateAnswerAverage();
        if (average <= 2) {

            visibilityChangeRequest.push({
                targetScreenIndex: Constants.SCREEN_10,
                active: true
            });

            visibilityChangeRequest.push({
                targetScreenIndex: Constants.SCREEN_14,
                active: true
            });

        } else if (average > 2 && average <= 3) {

            visibilityChangeRequest.push({
                targetScreenIndex: Constants.SCREEN_11,
                active: true
            });

            visibilityChangeRequest.push({
                targetScreenIndex: Constants.SCREEN_10,
                active: true
            });
        } else if (average > 3) {

            visibilityChangeRequest.push({
                targetScreenIndex: Constants.SCREEN_12,
                active: true
            });

            visibilityChangeRequest.push({
                targetScreenIndex: Constants.SCREEN_10,
                active: true
            });
        }
        return visibilityChangeRequest;
    }

    /**
     * Calculates the average pointing for the answers given by the user
     * @returns Average points of dependency to tobacco
     * */
    private calculateAnswerAverage(): number {

        // If the user selects the "selef-select" checkbox
        // we define the calification based on the selected
        // option.
        if (this.selfSelectStatus) {

            let selfSelectOption = $(this.questionsSelects[0]).val();
            switch (selfSelectOption) {
                case "0":
                    return this.LOW;
                case "1":
                    return this.MODERATE;
                case "2":
                    return this.SEVERE;
                default:
                    return this.LOW;
            }
        } // If the is not self-select, we calculate based on the 4 questions of the form
        else {
            let total: number = 0;

            for (var i = 1; i < this.questionsSelects.length; i++) {
                if ($(this.questionsSelects[i]).val()) {
                    let selectedOption = parseInt($(this.questionsSelects[i]).val() as string);
                    total += selectedOption;
                }
            }

            return total / this.TOTAL_ASSESMENT_QUESTIONS;
        }
    }

    public validateScreen(): boolean {
        if (this.selfSelectStatus) {
            let validationResult0 = this.validateRequiredSelectQuestion(0);
            return validationResult0;
        }
        else {

            // All the questions are required
            let validationResult1 = this.validateRequiredSelectQuestion(1);
            let validationResult2 = this.validateRequiredSelectQuestion(2);
            let validationResult3 = this.validateRequiredSelectQuestion(3);
            let validationResult4 = this.validateRequiredSelectQuestion(4);

            return validationResult1 && validationResult2 && validationResult3 && validationResult4;
        }
    }

    /**
     * Validates the questions with select option were answered
     */
    private validateRequiredSelectQuestion(questionIndex: number = 0): boolean {
        let questionContainer = $(this.screenDomElement.find(".FormSelection")[questionIndex]);
        let selectedOption = questionContainer.find("select").val();

        if (!selectedOption) {
            questionContainer.addClass("ValidationFail");
            let errorMessageContainer = questionContainer.find(".Form__Element__ValidationError");
            errorMessageContainer.html("This field is required");
            errorMessageContainer.show();

            return false;
        } else {
            questionContainer.removeClass("ValidationFail");
            let errorMessageContainer = questionContainer.find(".Form__Element__ValidationError");
            errorMessageContainer.html("");
            errorMessageContainer.hide();
            return true;
        }
    }

    /**
     * Shows the dependency message depending on the average obtained in the answers
     */
    private updateDependencyLevelMessage() {

        // Firsta validate if all the questions where answered
        let finishedAnswers: boolean = true;
        for (var i = 1; i < this.questionsSelects.length; i++) {
            if (!$(this.questionsSelects[i]).val()) {
                finishedAnswers = false;
            }
        }

        if (!finishedAnswers) {
            return;
        }

        // Add the message container in case doesn't exist yet
        if (this.screenDomElement.find(".Form__Element.FormStep #dependency-level-message").length == 0) {
            this.screenDomElement.find(".Form__Element.FormStep").append(`
                <div id="dependency-level-message" class="Form__Element FormParagraphText Form__Element--NonData" data-f-element-name="__field_14996" data-f-element-nondata="">
                    <p>Patient has a <strong class="vibrant-indigo"></strong></p>
                </div>
            `);
        }

        // Set the message that correspond to the average
        let message = "";
        let average: number = this.calculateAnswerAverage();

        if (average <= 2) {
            message = "low dependency.";
        } else if (average > 2 && average <= 3) {
            message = "moderate dependency.";
        } else if (average > 3) {
            message = "severe dependency";
        }

        this.screenDomElement.find(".Form__Element.FormStep #dependency-level-message p strong").html(message);

        this.enableNextButton();
    }

    public showScreen(): void {
        this.screenDomElement.show();
        this.recordAnalyticsPageViewEvent();
    }

    public loadScreenInitialStatus(): void {
        this.updateNextButtonStatus();
    }

    private updateNextButtonStatus() {
        let enableNextButton: boolean = true;
        this.screenDomElement.find(".FormSelection select").each(function (index, element) {
            if (!$(element).val()) {
                enableNextButton = false;
            }
        });

        if (enableNextButton) {
            this.enableNextButton();
        } else {
            this.disableNextButton();
        }
    }

    /**
     * Reset the Dropdowns depending if the user selected the option "Self-Select Dependency Option"
     * 
     */
    private clearDropdowns() {

        if (this.selfSelectStatus) {
            $(this.questionsSelects[0]).val("");
            for (var i = 1; i < this.questionsSelects.length; i++) {
                $(this.questionsSelects[i]).val(1);
            }
        }
        else {
            $(this.questionsSelects[0]).val(1);
            for (var i = 1; i < this.questionsSelects.length; i++) {
                $(this.questionsSelects[i]).val("");
            }
        }

        //this.screenDomElement.find(".Form__Element.FormStep #dependency-level-message").html('Patient has a <strong class="vibrant-indigo"></strong>')
        this.screenDomElement.find(".Form__Element.FormStep #dependency-level-message").remove();
    }
}